<template>
        <navbar-comp>
            <router-view/>
        </navbar-comp>
        <home-comp/>
        <about-comp/>
        <skills-comp>
                <template #skills >
                    <div id="skills" v-for="skill in displaySkills()" :key="skill.id">
                        <div class="text-center pt-5 mb-5" data-aos="fade-up"> </div>
                        <div class="row justify-content-center mx-3 py-3">
                            <div class="col-lg-5 col-col-md-4 col-sm-12 pb-2 align-content-center">
                                <h3 class="text-white text-center mb-5" data-aos="fade-up">Programming Skills</h3>
                                <div class="row">
                                    <div class="codeSkills mt-2" data-aos="fade-up">
                                        <div>
                                            <i :class="skill.programmingSkills[0].iconClass"></i>
                                        </div>
                                        <div>
                                            {{ skill.programmingSkills[0].language }}
                                        </div>
                                        <div>
                                            {{ skill.programmingSkills[0].level }}
                                        </div>   
                                    </div>
                                   <div class="codeSkills mt-2" data-aos="fade-up">
                                       <div>
                                           <i :class="skill.programmingSkills[1].iconClass"></i>
                                       </div>
                                       <div>
                                           {{ skill.programmingSkills[1].language }}
                                       </div>
                                       <div>
                                           {{ skill.programmingSkills[1].level }}
                                       </div>
                                   </div> 
                                   <div class="codeSkills mt-2" data-aos="fade-up">
                                       <div class="tailwind">
                                           <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0,0,256,256">
                                                <g fill="#fffbfb" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.33333,5.33333)"><path d="M24,9.604c-6.4,0 -10.4,3.199 -12,9.597c2.4,-3.199 5.2,-4.398 8.4,-3.599c1.826,0.456 3.131,1.781 4.576,3.247c2.352,2.387 5.075,5.151 11.024,5.151c6.4,0 10.4,-3.199 12,-9.598c-2.4,3.199 -5.2,4.399 -8.4,3.6c-1.825,-0.456 -3.13,-1.781 -4.575,-3.247c-2.353,-2.388 -5.077,-5.151 -11.025,-5.151zM12,24c-6.4,0 -10.4,3.199 -12,9.598c2.4,-3.199 5.2,-4.399 8.4,-3.599c1.825,0.457 3.13,1.781 4.575,3.246c2.353,2.388 5.077,5.152 11.025,5.152c6.4,0 10.4,-3.199 12,-9.598c-2.4,3.199 -5.2,4.399 -8.4,3.599c-1.826,-0.456 -3.131,-1.781 -4.576,-3.246c-2.352,-2.388 -5.075,-5.152 -11.024,-5.152z"></path></g></g>
                                            </svg>
                                       </div>
                                       <div>
                                           {{ skill.programmingSkills[2].language }}
                                       </div>
                                       <div>
                                           {{ skill.programmingSkills[2].level }}
                                       </div>
                                   </div>
                                   <div class="codeSkills mt-2" data-aos="fade-up">
                                       <div>
                                           <i :class="skill.programmingSkills[3].iconClass"></i>
                                       </div>
                                       <div>
                                           {{ skill.programmingSkills[3].language }}
                                       </div>
                                       <div>
                                           {{ skill.programmingSkills[3].level }}
                                       </div>
                                   </div>
                                   <div class="codeSkills mt-2" data-aos="fade-up">
                                       <div>
                                           <i :class="skill.programmingSkills[4].iconClass"></i>
                                       </div>
                                       <div>
                                           {{ skill.programmingSkills[4].language }}
                                       </div>
                                       <div>
                                           {{ skill.programmingSkills[4].level }}
                                       </div>
                                   </div>
                                   <div class="codeSkills mt-2" data-aos="fade-up">
                                       <div class="nextjs">
                                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0,0,256,256">
                                        <defs><linearGradient x1="24" y1="43.734" x2="24" y2="4.266" gradientUnits="userSpaceOnUse" id="color-1_MWiBjkuHeMVq_gr1"><stop offset="0" stop-color="#ffffff"></stop><stop offset="0.465" stop-color="#ffffff"></stop><stop offset="1" stop-color="#ffffff"></stop></linearGradient><linearGradient x1="30.512" y1="33.021" x2="30.512" y2="18.431" gradientUnits="userSpaceOnUse" id="color-2_MWiBjkuHeMVq_gr2"><stop offset="0.377" stop-color="#9a9a9a" stop-opacity="0.50196"></stop><stop offset="0.666" stop-color="#9a9a9a" stop-opacity="0.50196"></stop><stop offset="0.988" stop-color="#9a9a9a" stop-opacity="0.50196"></stop></linearGradient><linearGradient x1="22.102" y1="21.443" x2="36.661" y2="40.529" gradientUnits="userSpaceOnUse" id="color-3_MWiBjkuHeMVq_gr3"><stop offset="0.296" stop-color="#9a9a9a" stop-opacity="0.50196"></stop><stop offset="0.521" stop-color="#9a9a9a" stop-opacity="0.50196"></stop><stop offset="0.838" stop-color="#9a9a9a" stop-opacity="0.50196"></stop></linearGradient></defs><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.33333,5.33333)"><circle cx="24" cy="24" r="19.734" fill="url(#color-1_MWiBjkuHeMVq_gr1)"></circle><rect x="15.992" y="16.027" width="3.023" height="15.996" fill-opacity="0.50196" fill="#9a9a9a"></rect><rect x="29.035" y="15.957" width="2.953" height="14.59" fill="url(#color-2_MWiBjkuHeMVq_gr2)"></rect><path d="M36.781,38.094l-2.613,0.996l-18.176,-23.063h3.516z" fill="url(#color-3_MWiBjkuHeMVq_gr3)"></path></g></g>
                                        </svg>
                                        </div>
                                       <div>
                                           {{ skill.programmingSkills[5].language }}
                                       </div>
                                       <div>
                                           {{ skill.programmingSkills[5].level }}
                                       </div>
                                   </div>
                                   <div class="codeSkills mt-2" data-aos="fade-up">
                                       <div class="mysql">
                                        <svg  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0,0,300,150">
                                            <g fill="#ffffff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path d="M31.16797,8c-0.46875,-0.01172 -0.87891,0.16797 -1.08984,0.6875c-0.35937,0.87109 0.53516,1.72266 0.85547,2.16797c0.22266,0.30859 0.51172,0.65625 0.67188,1.00391c0.10547,0.23047 0.12109,0.46094 0.21094,0.70313c0.22266,0.59766 0.57813,1.27734 0.86328,1.83203c0.14453,0.28125 0.30469,0.57422 0.48828,0.82422c0.11328,0.15234 0.30469,0.22266 0.33594,0.45703c-0.1875,0.26563 -0.19922,0.67578 -0.30469,1.01172c-0.47656,1.50391 -0.29687,3.375 0.39453,4.48438c0.21484,0.34375 0.71875,1.07422 1.40625,0.79688c0.60156,-0.24609 0.46875,-1.00781 0.64063,-1.68359c0.03906,-0.14844 0.01563,-0.26172 0.09375,-0.36328v0.03125c0.17969,0.36719 0.36328,0.73438 0.54688,1.09766c0.41016,0.65625 1.13281,1.33984 1.74219,1.80469c0.31641,0.23828 0.56641,0.65234 0.97656,0.79297v-0.03125h-0.03125c-0.07812,-0.125 -0.20312,-0.17578 -0.30469,-0.27344c-0.23828,-0.23437 -0.50391,-0.52734 -0.69922,-0.79687c-0.55859,-0.75391 -1.05078,-1.58203 -1.49609,-2.44141c-0.21484,-0.41016 -0.40234,-0.86328 -0.58203,-1.28125c-0.07031,-0.16406 -0.07031,-0.40625 -0.21484,-0.49219c-0.19922,0.30859 -0.48828,0.55469 -0.64062,0.91797c-0.24219,0.57813 -0.27734,1.28516 -0.36719,2.01563c-0.05469,0.01953 -0.03125,0.00391 -0.05859,0.03125c-0.42578,-0.10547 -0.57812,-0.54297 -0.73437,-0.91797c-0.39844,-0.94922 -0.47656,-2.48047 -0.12109,-3.57031c0.08984,-0.28516 0.5,-1.17578 0.33594,-1.4375c-0.07812,-0.26172 -0.34375,-0.41016 -0.48828,-0.60937c-0.18359,-0.24609 -0.36328,-0.57031 -0.48828,-0.85547c-0.32812,-0.74219 -0.63672,-1.60156 -0.98437,-2.35156c-0.16406,-0.35937 -0.44141,-0.71875 -0.67187,-1.03906c-0.25391,-0.35156 -0.53516,-0.60937 -0.73437,-1.03906c-0.06641,-0.14844 -0.16406,-0.39062 -0.05859,-0.54687c0.03125,-0.10547 0.07813,-0.14844 0.18359,-0.18359c0.17578,-0.13672 0.66797,0.04297 0.85547,0.12109c0.48828,0.20313 0.89844,0.39844 1.3125,0.67188c0.19922,0.13281 0.39844,0.38672 0.64063,0.46094h0.27344c0.43359,0.09766 0.91406,0.02734 1.3125,0.15234c0.71094,0.21484 1.34766,0.55078 1.92188,0.91406c1.76172,1.10938 3.20313,2.69141 4.18359,4.57813c0.16016,0.30469 0.23047,0.59766 0.37109,0.91797c0.27734,0.64844 0.63281,1.32031 0.91406,1.95313c0.27734,0.63672 0.55078,1.27344 0.94531,1.80078c0.20703,0.27734 1.01172,0.42969 1.375,0.58203c0.25391,0.10938 0.67578,0.22266 0.91406,0.36719c0.46484,0.27734 0.91016,0.60938 1.34375,0.91797c0.21875,0.15234 0.88281,0.48438 0.91797,0.76172c-1.07422,-0.02734 -1.89453,0.07031 -2.59375,0.36719c-0.19922,0.08594 -0.51953,0.08594 -0.55078,0.33594c0.10547,0.11328 0.125,0.28516 0.21094,0.42578c0.16797,0.26953 0.44922,0.63281 0.70313,0.82422c0.27734,0.20703 0.55859,0.42969 0.85547,0.61328c0.52344,0.31641 1.10938,0.5 1.61719,0.82031c0.29688,0.19141 0.59766,0.42969 0.88672,0.64063c0.14453,0.10938 0.23828,0.27344 0.42578,0.33984v-0.03125c-0.09766,-0.125 -0.12109,-0.29687 -0.21094,-0.42578l-0.40234,-0.40234c-0.38672,-0.51172 -0.87891,-0.96484 -1.40234,-1.33984c-0.41797,-0.30078 -1.35156,-0.70703 -1.52344,-1.19141l-0.03125,-0.03125c0.29297,-0.03125 0.64063,-0.14062 0.91406,-0.21484c0.46094,-0.12109 0.86719,-0.08984 1.33984,-0.21094c0.21484,-0.0625 0.42969,-0.125 0.64453,-0.18359v-0.125c-0.23828,-0.24219 -0.41016,-0.57031 -0.67187,-0.79297c-0.68359,-0.58203 -1.42969,-1.16406 -2.19922,-1.64844c-0.42578,-0.26953 -0.95312,-0.44531 -1.40234,-0.67187c-0.15234,-0.07812 -0.41797,-0.11719 -0.51953,-0.24609c-0.23828,-0.30078 -0.36719,-0.68359 -0.55078,-1.03516c-0.38281,-0.73828 -0.75781,-1.54297 -1.09766,-2.32031c-0.23047,-0.52734 -0.38281,-1.05078 -0.67187,-1.52734c-1.38672,-2.27734 -2.87891,-3.65625 -5.19141,-5.00781c-0.49219,-0.28906 -1.08203,-0.39844 -1.70703,-0.54687c-0.33984,-0.02344 -0.67187,-0.04297 -1.01172,-0.0625c-0.20312,-0.08594 -0.41797,-0.33594 -0.60937,-0.46094c-0.48047,-0.30078 -1.42578,-0.82422 -2.20703,-0.83594zM34.47656,11.3125c-0.22266,-0.00391 -0.38281,0.02734 -0.55078,0.0625v0.03125h0.03125c0.10547,0.21875 0.29688,0.35938 0.42969,0.54688c0.10156,0.21484 0.19922,0.42969 0.30078,0.64453l0.03125,-0.03125c0.1875,-0.13281 0.27734,-0.34766 0.27734,-0.67187c-0.07812,-0.07812 -0.08984,-0.17969 -0.15234,-0.27344c-0.08984,-0.12891 -0.25781,-0.19922 -0.36719,-0.30859zM1.86719,23.99609c-0.30078,0.01172 -0.62891,0.07031 -0.98438,0.18359c-0.59375,0.17969 -0.88672,0.53516 -0.88672,1.25781v7.5625h2.00391v-7.37891l2.77734,6.30859c0.34375,0.78516 0.8125,1.06641 1.73047,1.06641c0.92188,0 1.37109,-0.28125 1.71484,-1.06641l2.77734,-6.14844v7.21875h2v-7.5625c0,-0.72266 -0.28906,-1.07812 -0.88672,-1.25781c-1.42187,-0.44922 -2.37891,-0.0625 -2.80859,0.91016l-2.85156,6.41406l-2.75781,-6.41406c-0.3125,-0.73047 -0.9375,-1.12891 -1.82812,-1.09375zM26.24609,24c-0.78906,0 -3.24609,0.09375 -3.24609,2v1.23438c0,0.875 0.76953,1.58984 2.4375,1.76563c0.1875,0.01172 0.375,0.02734 0.5625,0.02734c0,0 1.94531,-0.03906 2,-0.02734c1.125,0 1,0.875 1,1v1c0,0.13672 -0.03125,1 -1.01172,1h-4.98828v1h5.00781c0.65625,0 1.29297,-0.13672 1.80078,-0.375c0.84375,-0.38672 1.19141,-0.91016 1.19141,-1.59766v-1.42969c0,-1.53516 -1.90625,-1.59766 -3,-1.59766h-2c-0.78516,0 -0.90625,-0.47656 -1,-1v-1c0.09375,-0.39844 0.26953,-0.9375 0.96484,-1h5.03516v-1zM33.98047,24c-1.47656,0.20313 -1.99609,0.9375 -1.99609,2v5c0,0.97266 0.54297,1.55859 1.66016,1.86328c0.375,0.10547 0.71484,0.14844 1.03516,0.14844l2.22656,-0.01172h1.30859l1.11328,1h2.25l-1.54687,-1.39453c0.72656,-0.30078 0.95313,-0.76172 0.95313,-1.625v-4.98047c0,-1.0625 -0.69141,-1.79687 -2.16797,-2zM42,24v6.95703c0,1.20703 0.68359,1.88672 2.49219,2.02344c0.16797,0.00781 0.33984,0.01953 0.50781,0.01953h5v-1h-4.62109c-1.03125,0 -1.37891,-0.43359 -1.37891,-1.05078v-6.94922zM35.17188,25h2.57422c0.67969,0 1.13672,0.54688 1.23828,1c0,0 0.01563,4.65625 0.01563,5c0,0.34375 -0.19141,0.5 -0.19141,0.5l-0.54297,-0.5h-2.26562l1.11328,1h-1.94141c-0.69531,0 -1.08594,-0.51562 -1.1875,-1v-4.89844c0,-0.53125 0.40625,-1.10156 1.1875,-1.10156zM14,27c0.03906,0.03906 0,4.26172 0,4.34375c0.01563,0.875 1.125,1.64063 2.86328,1.65625h3.13672v0.06641c0,0.1875 0.13672,0.8125 -1,0.93359c-0.01172,0 -4.98828,0 -5,0v1h5.21484c0.88281,-0.02734 2.79688,-0.22656 2.78516,-1.75781c0,-0.02734 0.00781,-6.24219 0,-6.24219h-2v5c-0.03125,0 -2.47656,0.00781 -2.96875,0c-0.96484,-0.01562 -1.04687,-0.56641 -1.03125,-0.77734v-4.22266z"></path></g></g>
                                            </svg>
                                       </div>
                                       <div>
                                           {{ skill.programmingSkills[6].language }}
                                       </div>
                                       <div>
                                           {{ skill.programmingSkills[6].level }}
                                       </div>
                                   </div>
                                   <div class="codeSkills mt-2" data-aos="fade-up">
                                       <div>
                                           <i :class="skill.programmingSkills[7].iconClass"></i>
                                       </div>
                                       <div>
                                           {{ skill.programmingSkills[7].language }}
                                       </div>
                                       <div>
                                           {{ skill.programmingSkills[7].level }}
                                       </div>
                                   </div>
                                </div>
                            </div>
                            <div class="col-lg-1 col-col-md-4 col-sm-12"></div>
                            <div class="col-lg-5 col-col-md-4 col-sm-12 pb-2 align-content-center">
                                <h3 class="text-white text-center m-5" data-aos="fade-up">Soft Skills</h3>
                                <div class="row">
                                    <div class="softSkills mt-2" data-aos="fade-up">
                                        <div >
                                            <i :class="skill.softSkills[0].iconClass"></i>
                                        </div>
                                        <div>
                                            {{ skill.softSkills[0].softSkill }}
                                        </div>
                                        <div>
                                            {{ skill.softSkills[0].description }}
                                        </div>
                                    </div>
                                    <div class="softSkills mt-2" data-aos="fade-up">
                                        <div>
                                            <i :class="skill.softSkills[1].iconClass"></i>
                                        </div>
                                        <div>
                                            {{ skill.softSkills[1].softSkill }}
                                        </div>
                                        <div>
                                            {{ skill.softSkills[1].description }}
                                        </div>
                                    </div>
                                    <div class="softSkills mt-2" data-aos="fade-up">
                                        <div>
                                            <i :class="skill.softSkills[2].iconClass"></i>
                                        </div>
                                        <div>
                                            {{ skill.softSkills[2].softSkill }}
                                        </div>
                                        <div>
                                            {{ skill.softSkills[2].description }}
                                        </div>
                                    </div>
                                    <div class="softSkills mt-2" data-aos="fade-up">
                                        <div>
                                            <i :class="skill.softSkills[3].iconClass"></i>
                                        </div>
                                        <div>
                                            {{ skill.softSkills[3].softSkill }}
                                        </div>
                                        <div>
                                            {{ skill.softSkills[3].description }}
                                        </div>
                                    </div>
                                    <div class="softSkills mt-2" data-aos="fade-up">
                                        <div>
                                            <i :class="skill.softSkills[4].iconClass"></i>
                                        </div>
                                        <div>
                                            {{ skill.softSkills[4].softSkill }}
                                        </div>
                                        <div>
                                            {{ skill.softSkills[4].description }}
                                        </div>
                                    </div>
                                    <div class="softSkills mt-2" data-aos="fade-up">
                                        <div>
                                            <i :class="skill.softSkills[5].iconClass"></i>
                                        </div>
                                        <div>
                                            {{ skill.softSkills[5].softSkill }}
                                        </div>
                                        <div>
                                            {{ skill.softSkills[5].description }}
                                        </div>
                                    </div>
                                    <div class="softSkills mt-2" data-aos="fade-up">
                                        <div>
                                            <i :class="skill.softSkills[6].iconClass"></i>
                                        </div>
                                        <div>
                                            {{ skill.softSkills[6].softSkill }}
                                        </div>
                                        <div>
                                            {{ skill.softSkills[6].description }}
                                        </div>
                                    </div>
                                    <div class="softSkills mt-2" data-aos="fade-up">
                                        <div>
                                            <i :class="skill.softSkills[7].iconClass"></i>
                                        </div>
                                        <div>
                                            {{ skill.softSkills[7].softSkill }}
                                        </div>
                                        <div>
                                            {{ skill.softSkills[7].description }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
            </div>
        </template> 
    </skills-comp>
        <resume-comp/>
        <projects-comp>
            <template #projects>
                <div class="pb-4 pt-5" v-if="displayProjects()" id="projects">
                    <h2 class="mb-2 mt-5" data-aos="fade-up">Projects</h2>
                    <div class="container-fluid pt-5" id="project" >
                            <div class="row mt-2" v-for="project in displayProjects()" :key="project.id">
                                <div class="card mt-3 col-lg-4 col-md-4 col-sm-12 mx-2" data-aos="fade-up">
                                    <img :src="project.image" class="card-img-top pt-2" loading="lazy">
                                    <div class="card-body">
                                        <h5 class="card-title">{{ project.name }}</h5>
                                        <p class="card-text">{{ project.description }}</p>
                                        <a :href="project.github" target="blank" class="btn">Github</a> 
                                        <a :href="project.live" target="blank" class="btn">Live</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
                <div v-else>
                    <SpinnerComp/>
                </div>
            </template>
        </projects-comp>
        <contact-comp/>
        <footer-comp/>
</template>
<script>
import NavbarComp from '@/components/NavbarComp.vue';
import HomeComp from '@/components/HomeComp.vue';
import AboutComp from '@/components/AboutComp.vue';
import ResumeComp from '@/components/ResumeComp.vue';
import SkillsComp from '@/components/SkillsComp.vue';
import ProjectsComp from '@/components/ProjectsComp.vue';
import ContactComp from '@/components/ContactComp.vue';
import FooterComp from '@/components/FooterComp.vue';
import SpinnerComp from '@/components/SpinnerComp.vue';
export default {
components:{
    NavbarComp,
    HomeComp,
    AboutComp,
    ResumeComp,
    SkillsComp,
    ProjectsComp,
    ContactComp,
    FooterComp,
    SpinnerComp
},
    methods:{
        displaySkills(){
            return this.$store.state.skills
        },
        displayProjects(){
            return this.$store.state.projects
        },
        displayTestimonials(){
            return this.$store.state.testimonials
        }
},
computed:{
    getData(){
       return this.$store.dispatch('getData')
    }
},
mounted(){
    this.getData
}

}
</script>
<style scoped>
    #position{
        position:static ;
    }
    h2{
        text-align: center;
        color:aliceblue;
    }
    #skills{
        background-color: #125a3e;
        width:100vw;
    }
    #skills .codeSkills{
        width:155px;
        height:180px;
        margin:1px;
        font-size:100%;
        transition: 0.5s;
        color:aliceblue;
        background-color: #ffc695;
        margin: auto;
        display:flex;
        flex-direction: column;
        justify-content: center;
        border-radius:50%;
    }
    .codeSkills:hover{
        text-shadow:2px 2px #125a3e;
        cursor:pointer;
        box-shadow:8px 8px 8px 10px rgb(0,0,0,0.5)
    }
    .mysql{
        transition: 0.5s;
    }
    .codeSkills:hover .mysql{
        filter:drop-shadow(2px 2px #125a3e);
        transform: rotate(5deg);
    }
    .codeSkills:hover .nextjs{
        filter:drop-shadow(2px 2px #125a3e);
        transform: rotate(5deg);
    }
    .codeSkills:hover .tailwind{
        filter:drop-shadow(2px 2px #125a3e);
        transform: rotate(5deg);
    }
    .codeSkills i{
        font-size:55px;
        transition: 0.8s;
    }
    .codeSkills:hover i{
        text-shadow:2px 2px #125a3e;
        transform: rotate(5deg);
    }
    .codeSkills svg{
        margin-bottom:8px;
        width:72px;
        height:50px;
    }
    #skills .softSkills{
        width:155px;
        height:180px;
        font-size:100%;
        transition: 0.5s;
        color:aliceblue;
        background-color: #ffc695;
        margin: auto;
        display:flex;
        flex-direction: column;
        justify-content: center;
        border-radius:50%;
    }
    .softSkills:hover{
        text-shadow:2px 2px #125a3e;
        cursor:pointer;
        box-shadow:8px 8px 8px 10px rgb(0,0,0,0.5)
    }
    .softSkills i{
        font-size:55px;
        transition:0.8s;
    }
    .softSkills:hover i{
        text-shadow:2px 2px #125a3e;
        transform: rotate(5deg);
    }
    #projects{
        background-color: #125a3e;
    }
    #project {
        display:grid;
        grid-template-columns: repeat(3, 1fr);
        place-items: center;
        margin:auto;
        width:100vw;
    }
    #projects .card{
        background-color: #ffc695;
        color:aliceblue;
        width:18rem;
        border:none;
        height:23rem;
        transition:0.6s;
    }
    #project .card:hover{
        background-color: #ffc695;
        cursor: pointer;
        box-shadow:1px 8px 8px 8px rgb(0,0,0,0.5);
        transform: rotate(0.9deg);
    }
    #projects h2{
        margin-top:5vh;
    }
    #projects .card img{
        width:100%;
        height:20vh;
    }
    #project:hover > :not(:hover){
        opacity: .9;
    }
    .btn{
        background-color: #125a3e;
        margin:0.1em;
        transition: 1s;
        color:aliceblue;
        font-weight: 600;
        border:2px  solid transparent;
    }
    .btn:hover{
        background-color: #ffc695;
        border:2px  solid #125a3e;
        color:#125a3e;
        font-weight: 900;
    }

@media only screen and (max-width:780px){
    #skills .codeSkills{
        width:285px;
        height:280px;
        margin:auto;
        display:flex;
        flex-direction: column;
        justify-content: center;
        font-size:24px;
        transition: 1s;
    }
    #skills .softSkills{
        width:285px;
        height:280px;
        margin:auto;
        display:flex;
        flex-direction: column;
        justify-content: center;
        font-size:24px;
        transition: 1s;
    }
    #project {
        display:grid;
        grid-template-columns: repeat(2, 1fr);
        place-items: center;
        margin:auto;
        width:100vw;
    }
}
@media only screen and (max-width:600px){
    #skills .codeSkills{
        width:285px;
        height:280px;
        margin:auto;
        display:flex;
        flex-direction: column;
        justify-content: center;
        font-size:24px;
        transition: 1s;
    }
    #skills .softSkills{
        width:285px;
        height:280px;
        margin:auto;
        display:flex;
        flex-direction: column;
        justify-content: center;
        font-size:24px;
        transition: 1s;
    }
    #project{
        display:grid;
        grid-template-columns: repeat(1, 1fr);
        place-items: center;
        margin:auto;
        width:100vw;
    }
}
</style>